// src/frontend/js/modern/core/init-gate.js
//
// Initialization gate: the FIRST user mutation waits (bounded) for the initial
// server data-sync to settle, so optimistic operations never seed themselves
// from a stale/empty localStorage. The gate is capped with a timeout so an
// unreachable server can never permanently block the UI.

let gate = Promise.resolve();

/** Called by system.js once the initial sync has been kicked off. */
export function setInitGate(promise) {
	gate = Promise.resolve(promise).catch(() => {});
}

/**
 * Resolves when the initial sync settled, or after timeoutMs whichever first.
 */
export function waitForInit(timeoutMs = 2500) {
	let timer = null;
	const timeout = new Promise((resolve) => {
		timer = setTimeout(resolve, timeoutMs);
	});
	return Promise.race([gate, timeout]).finally(() => clearTimeout(timer));
}
